import axios from "axios";
import { wait } from "src/utils/wait";

const deployEnvironment = require("../../deployEnvironment.js");
const API = deployEnvironment;
const STORAGE_KEY = "accessToken";

class InboundProcessAPI {
  async getInboundRequestEmailHistory(inboundRequestId) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);
    const response = await axios.get(
      `${API}/api/inbound-request/email-history/${inboundRequestId}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
    return response.data;
  }
  async verifyPurchaseOrderHash(purchaseOrderHash) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const response = await axios.post(
      `${API}/api/inbound-request/verifyPurchaseOrderHash`,
      { po_id: purchaseOrderHash },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    const POIsValid = response.data;

    return new Promise((resolve, reject) => {
      try {
        if (!POIsValid) {
          reject(new Error("Unauthorized"));
          return;
        }

        resolve(POIsValid);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }
  async getPurchaseOrder(po_id) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const response = await axios.post(
      `${API}/api/inbound-request/getPurchaseOrder`,
      { po_id },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    const purchaseOrder = response.data.purchaseOrder;

    return new Promise((resolve, reject) => {
      try {
        if (!purchaseOrder) {
          reject(new Error("Unauthorized"));
          return;
        }

        resolve(purchaseOrder);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }
  async getPurchaseOrders() {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const response = await axios.get(
      `${API}/api/inbound-request/getPurchaseOrders`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    const purchaseOrders = response.data.purchaseOrders;

    return new Promise((resolve, reject) => {
      try {
        if (!purchaseOrders) {
          reject(new Error("Unauthorized"));
          return;
        }

        resolve(purchaseOrders);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }
  async getPurchaseOrdersBrand() {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const response = await axios.get(
      `${API}/api/inbound-request/getPurchaseOrdersBrand`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    const purchaseOrders = response.data.purchaseOrders;

    return new Promise((resolve, reject) => {
      try {
        if (!purchaseOrders) {
          reject(new Error("Unauthorized"));
          return;
        }

        resolve(purchaseOrders);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }
  async getPurchaseOrdersSupplier() {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const response = await axios.get(
      `${API}/api/inbound-request/getPurchaseOrdersSupplier`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    const purchaseOrders = response.data.purchaseOrders;

    return new Promise((resolve, reject) => {
      try {
        if (!purchaseOrders) {
          reject(new Error("Unauthorized"));
          return;
        }

        resolve(purchaseOrders);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }
  async getPOItems(purchaseOrderHash) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const response = await axios.post(
      `${API}/api/inbound-request/getPOItems`,
      { po_id: purchaseOrderHash },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    const POItems = response.data.POItems;

    return new Promise((resolve, reject) => {
      try {
        if (!POItems) {
          reject(new Error("Unauthorized"));
          return;
        }

        resolve(POItems);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }
  async getInboundRequest(inboundRequestId) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const response = await axios.post(
      `${API}/api/inbound-request/getInboundRequest`,
      { inboundRequestId },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    const inboundRequest = response.data.inboundRequest;

    return new Promise((resolve, reject) => {
      try {
        if (!inboundRequest) {
          reject(new Error("Unauthorized"));
          return;
        }

        resolve(inboundRequest);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }
  async getInboundRequestQuantities(inboundRequestId, itemQuantities) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const response = await axios.post(
      `${API}/api/inbound-request/getInboundRequestQuantities`,
      { inboundRequestId, itemQuantities },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    const calculatedNetTotal = response.data.calculatedNetTotal;

    return new Promise((resolve, reject) => {
      try {
        if (!calculatedNetTotal) {
          reject(new Error("Unauthorized"));
          return;
        }

        resolve(calculatedNetTotal);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }
  async getInboundRequests() {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const response = await axios.get(
      `${API}/api/inbound-request/getInboundRequests`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    const inboundRequests = response.data.inboundRequests;

    return new Promise((resolve, reject) => {
      try {
        if (!inboundRequests) {
          reject(new Error("Unauthorized"));
          return;
        }

        resolve(inboundRequests);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }
  async getInboundASNs() {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const response = await axios.get(
      `${API}/api/inbound-request/getInboundASNs`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    const inboundRequests = response.data.inboundRequests;

    return new Promise((resolve, reject) => {
      try {
        if (!inboundRequests) {
          reject(new Error("Unauthorized"));
          return;
        }

        resolve(inboundRequests);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }
  async getInboundRequestsOfBrand(brandName) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const response = await axios.post(
      `${API}/api/inbound-request/getInboundRequestsOfBrand`,
      { brandName },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    const inboundRequests = response.data.inboundRequests;

    return new Promise((resolve, reject) => {
      try {
        if (!inboundRequests) {
          reject(new Error("Unauthorized"));
          return;
        }

        resolve(inboundRequests);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }
  async getInboundASNsOfBrand(brandName) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const response = await axios.post(
      `${API}/api/inbound-request/getInboundASNsOfBrand`,
      { brandName },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    const inboundRequests = response.data.inboundRequests;

    return new Promise((resolve, reject) => {
      try {
        if (!inboundRequests) {
          reject(new Error("Unauthorized"));
          return;
        }

        resolve(inboundRequests);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }
  async getInboundRequestsOfSupplier(supplierId) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const response = await axios.post(
      `${API}/api/inbound-request/getInboundRequestsOfSupplier`,
      { supplierId },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    const inboundRequests = response.data.inboundRequests;

    return new Promise((resolve, reject) => {
      try {
        if (!inboundRequests) {
          reject(new Error("Unauthorized"));
          return;
        }

        resolve(inboundRequests);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }
  async getInboundASNsOfSupplier(supplierId) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const response = await axios.post(
      `${API}/api/inbound-request/getInboundASNsOfSupplier`,
      { supplierId },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    const inboundRequests = response.data.inboundRequests;

    return new Promise((resolve, reject) => {
      try {
        if (!inboundRequests) {
          reject(new Error("Unauthorized"));
          return;
        }

        resolve(inboundRequests);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }
  async getInboundRequestsItemsQuantityOfPO(purchaseOrder) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const response = await axios.post(
      `${API}/api/inbound-request/getInboundRequestsItemsQuantityOfPO`,
      { purchaseOrder },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    const inboundRequestsItemsQuantityOfPO =
      response.data.inboundRequestsItemsQuantityOfPO;

    return new Promise((resolve, reject) => {
      try {
        if (!inboundRequestsItemsQuantityOfPO) {
          reject(new Error("Unauthorized"));
          return;
        }

        resolve(inboundRequestsItemsQuantityOfPO);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }
  async createInboundRequest(formData) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    await axios.post(
      `${API}/api/inbound-request/createInboundRequest`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }
  async editInboundRequest(formData) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    await axios.post(
      `${API}/api/inbound-request/editInboundRequest`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }
  async confirmExtraUnitsReceived(inboundRequestId, extraUnitsItems = []) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    await axios.post(
      `${API}/api/inbound-request/confirmExtraUnitsReceived`,
      { inboundRequestId, extraUnitsItems },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }
  async confirmMissingItemsChoice(
    inboundRequestId,
    uploadCNForMissingItems,
    shipMissingItems,
    missingItemsCreditNoteFile = null,
  ) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    if (missingItemsCreditNoteFile instanceof File) {
      const formData = new FormData();
      formData.append("inboundRequestId", inboundRequestId);
      formData.append("uploadCNForMissingItems", uploadCNForMissingItems);
      formData.append("shipMissingItems", shipMissingItems);
      formData.append("missingItemsCreditNote", missingItemsCreditNoteFile);

      await axios.post(
        `${API}/api/inbound-request/confirmMissingItemsChoice`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
        },
      );

      return;
    }

    await axios.post(
      `${API}/api/inbound-request/confirmMissingItemsChoice`,
      {
        inboundRequestId,
        uploadCNForMissingItems,
        shipMissingItems,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }
  async saveCreditNote(inboundRequestId, creditNoteFile) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const formData = new FormData();
    formData.append("inboundRequestId", inboundRequestId);
    formData.append("creditNote", creditNoteFile);

    await axios.post(`${API}/api/inbound-request/saveCreditNote`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }
  async submitInboundRequest(id, skipPending = false) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    await axios.post(
      `${API}/api/inbound-request/submitInboundRequest`,
      { inboundRequestId: id, skipPending },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }
  async draftInboundRequest(formData) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    await axios.post(
      `${API}/api/inbound-request/draftInboundRequest`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }
  async setToPendingInboundRequest(formData) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    await axios.post(
      `${API}/api/inbound-request/setToPendingInboundRequest`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }
  async approveInboundRequest(
    id,
    incoterm,
    inbshipRequestDate,
    expectedDeliveryDate,
    approvalMemo,
    POItemsToUpdate,
    POItemsHistory,
  ) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const response = await axios.post(
      `${API}/api/inbound-request/approveInboundRequest`,
      {
        inboundRequestId: id,
        incoterm,
        inbshipRequestDate,
        expectedDeliveryDate,
        approvalMemo,
        POItemsToUpdate,
        POItemsHistory,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    const status = response.data.status;
    const message = response.data.message;

    return new Promise((resolve, reject) => {
      try {
        if (status !== 200) {
          reject(message);
          return;
        }

        resolve(message);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }
  async authorizeInboundRequest(id) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const response = await axios.post(
      `${API}/api/inbound-request/authorizeInboundRequest`,
      {
        inboundRequestId: id,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    const status = response.data.status;
    const message = response.data.message;

    return new Promise((resolve, reject) => {
      try {
        if (status !== 200) {
          reject(message);
          return;
        }

        resolve(message);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }
  async closeInboundRequest(inboundRequestId) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    await axios.post(
      `${API}/api/inbound-request/closeInboundRequest`,
      {
        inboundRequestId,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }
  async markInboundRequestAsReceived(inboundRequestId) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    await axios.post(
      `${API}/api/inbound-request/markInboundRequestAsReceived`,
      {
        inboundRequestId,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }
  async notifyChangeRequest(inboundRequestId, note) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    await axios.post(
      `${API}/api/inbound-request/notifyChangeRequest`,
      {
        inboundRequestId,
        note,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }
  async submitPickUpDetails(formData) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    await axios.post(
      `${API}/api/inbound-request/submitPickUpDetails`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }
  async addHistoryRecord(id, type, message) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    await axios.post(
      `${API}/api/inbound-request/addHistoryRecord`,
      { inboundRequestId: id, type, message },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }
  async getIncotermField(id) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const response = await axios.post(
      `${API}/api/inbound-request/getIncotermField`,
      { id },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    const incoterm = response.data.incoterm;

    return new Promise((resolve, reject) => {
      try {
        if (!incoterm) {
          reject(new Error("Unauthorized"));
          return;
        }

        resolve(incoterm);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }
  async saveChangesAddInboundRequest(formData) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const response = await axios.post(
      `${API}/api/inbound-request/saveChangesAddInboundRequest`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    const inboundRequestId = response.data.inboundRequestId;

    return new Promise((resolve, reject) => {
      try {
        if (!inboundRequestId) {
          reject(new Error("Unauthorized"));
          return;
        }

        resolve(inboundRequestId);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }

  async addInboundRequestNote(formData) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    await axios.post(
      `${API}/api/inbound-request/addInboundRequestNote`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }

  async editInboundRequestNote(formData) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    await axios.post(
      `${API}/api/inbound-request/editInboundRequestNote`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }
  async deleteInboundRequestNote(inboundRequestId, noteId) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    await axios.post(
      `${API}/api/inbound-request/deleteInboundRequestNote`,
      { inboundRequestId, noteId },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }
  async getBrandTolerances() {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const response = await axios.get(`${API}/api/brands/tolerances`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const brandTolerances = response.data;

    return new Promise((resolve, reject) => {
      try {
        if (!brandTolerances) {
          reject(new Error("Unauthorized"));
          return;
        }
        resolve(brandTolerances);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }
  async updateBrandTolerances(formData) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const response = await axios.post(
      `${API}/api/brands/set-tolerances`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    const status = response.data.status;
    const message = response.data.message;

    return new Promise((resolve, reject) => {
      try {
        if (status !== 200) {
          reject(new Error("Failed to update brand tolerances"));
          return;
        }

        resolve(message);
      } catch (err) {
        console.log(err);
        reject(new Error("Internal server error"));
      }
    });
  }
  async getPickupAutocompleteData(inboundRequestId) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const response = await axios.post(
      `${API}/api/inbound-request/getPickupAutocompleteData`,
      { inboundRequestId },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    const pickupAutocompleteData = response.data;

    return new Promise((resolve, reject) => {
      try {
        if (!pickupAutocompleteData) {
          reject(new Error("Unauthorized"));
          return;
        }

        resolve(pickupAutocompleteData);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }
  async getSupplierAddresses() {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const response = await axios.get(
      `${API}/api/pa-supplier/getSupplierAddresses`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    const supplierAddresses = response.data;

    return new Promise((resolve, reject) => {
      try {
        if (!supplierAddresses) {
          reject(new Error("Unauthorized"));
          return;
        }

        resolve(supplierAddresses);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }
  async getSupplierAddressesByPurchaseOrder(purchaseOrderId) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const response = await axios.post(
      `${API}/api/pa-supplier/getSupplierAddressesByPurchaseOrder`,
      { purchaseOrderId },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    const supplierAddresses = response.data;

    return new Promise((resolve, reject) => {
      try {
        if (!supplierAddresses) {
          reject(new Error("Unauthorized"));
          return;
        }

        resolve(supplierAddresses);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }
  async approvePickupDetails(id) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const response = await axios.post(
      `${API}/api/inbound-request/approvePickupDetails`,
      {
        inboundRequestId: id,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    const status = response.data.status;
    const message = response.data.message;

    return new Promise((resolve, reject) => {
      try {
        if (status !== 200) {
          reject(message);
          return;
        }

        resolve(message);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }
}

export const inboundProcessApi = new InboundProcessAPI();
